import React, { useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Modal } from 'ui-components/components/modal';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import AsModal from '../../../../../components/as-modal';
import { V2IframeService } from '../../../../../services/v2-iframe-service';
import { getReferenceData } from '../../../../../store/reference-data/reference-data.actions';
import { listenToMessages } from '../../../../../services/iframe-message-listener-service';
import style from './marketplace-setup.module.less';

const V2MarketplaceSetupModal = ({ marketplaceId, onClose, onSave }) => {
  const [subscriptionToMessage, setSubscriptionToMessage] = useState();
  const dispatch = useDispatch();
  const url = `${V2IframeService.getv2iFrameUrl()}/#/marketplaces/setup/${marketplaceId}?v3iframe=true`;

  useEffect(() => {
    const cleanup = () => {
      if (!subscriptionToMessage) {
        return;
      }
      subscriptionToMessage();
      setSubscriptionToMessage(undefined);
    };
    if (subscriptionToMessage) {
      return cleanup;
    }
    const newListener = (message) => {
      if (message.eventType === 'v2MarketplaceModalClosed') {
        onClose();
        return;
      }
      if (message.eventType === 'v2MarketplaceConnected') {
        dispatch(getReferenceData());
        onSave();
      }
    };
    setSubscriptionToMessage(listenToMessages(newListener));
    return cleanup;
  }, [subscriptionToMessage, setSubscriptionToMessage, dispatch, onClose, onSave]);

  return (
    <Modal className={style['marketplace-setup-modal']} size='custom'>
      <ModalHeader closeModal={onClose}>
        <FormattedMessage defaultMessage='Connect a new Marketplace' description='v2 marketplace setup modal header' id='PE0lwt' />
      </ModalHeader>
      <ModalBody className={style['modal-body']}>
        <iframe className={style.iframe} src={url} title='v2 marketplace iframe' />
      </ModalBody>
    </Modal>
  );
};

V2MarketplaceSetupModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  marketplaceId: PropTypes.number.isRequired,
  onSave: PropTypes.func.isRequired,
};

export default AsModal(V2MarketplaceSetupModal);
